// API Configuration
// Change this URL when deploying your backend to Vercel or other platforms

const API_CONFIG = {
    // Development (localhost)
    // DEVELOPMENT: 'http://localhost:5000',
    DEVELOPMENT: 'https://websitebuilder-backend.onrender.com',


    // Production (your Vercel URL - update this when you deploy)
    PRODUCTION: 'https://websitebuilder-backend.onrender.com',

    // Environment detection
    get BASE_URL() {
        // Check if we're in production
        if (process.env.NODE_ENV === 'production') {
            return this.PRODUCTION;
        }

        // For development, use localhost
        return this.DEVELOPMENT;
    }
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${API_CONFIG.BASE_URL}/${cleanEndpoint}`;
};

// Export the base URL for direct use
export const API_BASE_URL = API_CONFIG.BASE_URL;

export default API_CONFIG;
